package com.fireavert.units.add_new_unit_csv.data_models

data class SkippedCSVRow(
    val unitNumber: String,
    val reasons: List<String>
)
